<template>
    <div class="wrapper-outer">
        <div class="image__wrapper">
            <div class="image-dots-wrapper"></div>
        </div>
        <div class="wrapper">
            <div class="tile__wrapper">
                <div class="tile">
                    <h1 class="heading">Brno</h1>
                    <p class="paragraph-main-medium">
                        Brno is a cultural city with a vibrant social scene – including sports, meet-ups, parties,
                        gaming
                        events, and more. It’s also a hub of knowledge and education, with one of the largest
                        exhibition
                        centers in Europe, which hosts a number of international conferences, expos, and trade fairs
                        every
                        year.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "PragueBanner"
  };
</script>

<style scoped lang="scss">
    @import "../../assets/scss/globals";
    @import "~@bistudio/bohemia-vue-components/dist/scss/colors";
    @import "~@bistudio/bohemia-vue-components/dist/scss/sizes";
    @import "~@bistudio/bohemia-vue-components/dist/scss/fonts";
    @import "~@bistudio/bohemia-vue-components/dist/scss/breakpoints";

    $bg-color: #ffffff;
    $dot-color: $dusty-gray;
    $header-overlap: 1700px;

    // Dimensions
    $dot-size: 2px;
    $dot-space: 1px;

    .heading {
        text-transform: none;
        color: white;
        font-size: 66px;
        @media (max-width: $tablet) {
            font-size: 36px;
        }
    }

    .paragraph-main-medium, .heading-53 {
        color: white;
        margin-top: 38px;
    }

    .paragraph-main-medium {
        letter-spacing: 0.13px;
        line-height: 40px;

        @media(max-width: $compact) {
            margin-top: 38px;
            letter-spacing: 0.1px;
            line-height: 24px;
        }
    }


    .wrapper-outer {
        position: relative;
        margin-top: 72px;
        margin-bottom: 400px;
        min-height: 600px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        @media (max-width: $tablet) {
            margin-bottom: 1000px;
        }

        @media (max-width: 425px) {
            margin-bottom: 150px;
        }
    }

    .wrapper {
        margin: auto;
        width: 100%;
        z-index: 2;
        max-width: $sub-nav-container-width;
        margin-bottom: -300px;

        @media (max-width: 1024px) {
            padding-left: 40px;
        }

        @media (max-width: $tablet) {
            margin-bottom: 140px;
            padding: 10px;
        }


    }

    .image__wrapper {
        position: absolute;
        top: 0;
        width: 56%;
        height: 125%;
        right: 0;
        z-index: 2;
        background-image: url(/static/img/expat_page/brno-new_2.jpg);
        background-size: 50% 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;

        @media (max-width: $tablet) {
            width: 100%;
            top: 700px;
        }

        @media (max-width: 425px) {
            height: 218px;
        }
    }

    .tile {
        background-color: $mine-shaft;
        position: relative;
        padding: 76px;
        max-width: 720px;
        min-height: 559px;

        @media (max-width: 1100px) {
            padding: 40px;
        }

        @media (max-width: 1024px) {
            max-width: 100%;

        }

        @media (max-width: $compact) {
            margin: 10px;
        }

        @media (max-width: 320px) {
            padding: 25px;
        }

        &:before {
            content: '';
            background-image: linear-gradient(270deg, #00ba88 0%, #00b5f2 100%);
            z-index: -3;
            width: 100%;
            height: 100%;
            left: -18px;
            bottom: -18px;
            position: absolute;

            @media (max-width: $compact) {
                left: 18px;
                bottom: -18px;
            }

        }
    }

    .image-dots-wrapper {
        position: relative;
        width: 100%;
        height: 60px;
        margin-top: -60px;


        &:before {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            background: radial-gradient($dot-color 20%, rgba(0, 0, 0, 0) 10%), radial-gradient($dot-color 15%, rgba(0, 0, 0, 0) 10%), $bg-color;
            background-position: 10px 10px, 10px 10px;
            -webkit-background-origin: padding-box;
            background-origin: padding-box;
            -webkit-background-clip: border-box;
            background-clip: border-box;
            -webkit-background-size: 4px 4px;
            background-size: 10px 10px;


            @media (max-width: $compact) {
                left: 0;
            }
        }
    }


    .responsive--img {
        width: 100%;
        max-width: 100%;
        height: auto;
    }

</style>


// WEBPACK FOOTER //
// src/components/expatsPageComponents/BrnoBanner.vue